import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/Header";
import Table from "react-bootstrap/Table";
import Form from "react-bootstrap/Form";
import Sidebar from "../../components/Sidebar";
import { RiEyeLine } from "react-icons/ri";
import { ProfileContext } from "../../context/ProfileContext";
import Loader from "../../components/Loader";
import { dateFormatter } from "../../utils/helper";


function PatientRecord() {
  const { profile, fetchData, pagination, error } = useContext(ProfileContext);
  const [allUsers, setAllUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [sortField, setSortField] = useState("createdAt");
  const [sortDirection, setSortDirection] = useState(-1);

  useEffect(() => { if (allUsers.length > 0) { handleSort(sortField); } }, [sortField, sortDirection]);

  useEffect(() => {
    if (profile && Array.isArray(profile)) {
      const sortedUsers = [...profile].sort((a, b) => {
        let valA, valB;
        if (sortField === "full_name") {
          valA = (a.full_name || "").toLowerCase();
          valB = (b.full_name || "").toLowerCase();
          return valA.localeCompare(valB) * sortDirection;
        }
        else if (sortField === "createdAt") {
          valA = isNaN(a[sortField]) ? new Date(a[sortField] || 0) : new Date(parseInt(a[sortField], 10));
          valB = isNaN(b[sortField]) ? new Date(b[sortField] || 0) : new Date(parseInt(b[sortField], 10));
          return (valA - valB) * sortDirection;
        }
        return 0;
      });
      setAllUsers(sortedUsers);
      setIsLoading(false);
    }
    else {
      setAllUsers([]);
      setIsLoading(true);
    }
  }, [profile, sortField, sortDirection]);

  const handleNext = () => {
    if (pagination && pagination.currentPage < pagination.totalPages) {
      setIsLoading(true);
      fetchData(pagination.currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (pagination && pagination.currentPage > 1) {
      setIsLoading(true);
      fetchData(pagination.currentPage - 1);
    }
  };

  const getPaginationText = () => {
    if (!pagination || pagination.totalCount === 0) { return }
    const start = (pagination.currentPage - 1) * pagination.limit + 1;
    const end = Math.min(pagination.currentPage * pagination.limit, pagination.totalCount);
    return `${start}-${end} of ${pagination.totalCount} items`;
  };

  const handleSort = (field) => {
    const sortedUsers = [...allUsers].sort((a, b) => {
      let valA, valB;

      if (field === "full_name") {
        valA = (a.full_name || "").toLowerCase();
        valB = (b.full_name || "").toLowerCase();
        return valA.localeCompare(valB) * sortDirection;
      }
      else if (field === "createdAt") {
        valA = isNaN(a[field]) ? new Date(a[field] || 0) : new Date(parseInt(a[field], 10));
        valB = isNaN(b[field]) ? new Date(b[field] || 0) : new Date(parseInt(b[field], 10));
        return (valA - valB) * sortDirection;
      }
      return 0;
    });
    setAllUsers(sortedUsers);
  };

  return (
    <>
      <Loader isLoading={isLoading} />
      <div className="container-fluid">
        <Header />
        <div className="row">
          <Sidebar />
          <div className="col-9 main-dash-left">
            <section className="back-dashboard-sec comn-dashboard-page">
              <div className="notifi-list d-flex">
                <div>
                  <h6 className="comm_page_heading">Patient Record Management</h6>
                  <p className="comm_page_sub_heading">
                    Centralized system for managing patient records, tracking consultation history, treatment plans, and referrals.
                  </p>
                </div>
                <div className="d-flex sort_by_filter_outer">
                  <div className="head">Sort By: </div>
                  <div className="dropdown_inner_list_select">
                    <Form.Select value={sortField}
                      onChange={(e) => {
                        const selectedField = e.target.value;
                        if (selectedField === sortField) { setSortDirection(sortDirection * -1); }
                        else {
                          setSortField(selectedField);
                          setSortDirection(selectedField === "createdAt" ? -1 : 1);
                        }
                      }}
                    >
                      <option value="createdAt">Date</option>
                      <option value="full_name">Patient Name</option>
                    </Form.Select>
                  </div>
                </div>
              </div>
              <div className="comm-table pt-0">
                {error && <div className="text-center text-danger">{error}</div>}

                {profile && profile.length > 0 ?
                  <Table>
                    <thead>
                      <tr className="head-class-td">
                        <th>Sr. no.</th>
                        <th>Patient ID</th>
                        <th>Patient's Name</th>
                        <th>Date of Registration</th>
                        <th width="10%">Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {allUsers && allUsers.length > 0 ? (
                        allUsers.map((patient, index) => {
                          return (
                            <tr key={patient._id}>
                              <td>{(pagination.currentPage - 1) * pagination.limit + index + 1}</td>
                              <td className="id_txt">{`#${patient?.patient_id}`}</td>
                              <td>{patient.full_name}</td>
                              <td>{dateFormatter(patient?.createdAt)}</td>
                              {/* <td>{patient.condition || "Not specified"}</td> */}
                              <td>
                                <Link className="table-view-btn" to={`/patient-record-details`} state={{ patient, id: index + 25001 }}>
                                  <RiEyeLine />
                                </Link>
                              </td>
                            </tr>
                          )
                        })
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center">No patient records found</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                  :
                  <h2>No Patient record Found !!</h2>
                }


              </div>
              {profile && profile.length > 10 &&
                <div className="d-flex table_bottom_row">
                  <h4 className="page_count_txt">{getPaginationText()}</h4>
                  <div className="d-flex btn_grp">
                    <button className="table_bott_btn" onClick={handlePrevious} disabled={!pagination || pagination.currentPage <= 1}>Previous</button>
                    <button className="table_bott_btn" onClick={handleNext} disabled={!pagination || pagination.currentPage >= pagination.totalPages}>Next</button>
                  </div>
                </div>
              }
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default PatientRecord;
